export class ApiError extends Error {
  status: number;
  data?: unknown;

  constructor(message: string, status: number, data?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export const getErrorMessage = (error: unknown, fallback = 'Something went wrong. Please try again.') => {
  if (error instanceof ApiError) {
    const responseData = error.data as Record<string, unknown> | undefined;
    const message = responseData?.message;

    if (typeof message === 'string' && message.trim()) {
      return message;
    }

    if (typeof responseData?.data === 'string' && responseData.data.trim()) {
      return responseData.data;
    }

    return error.message;
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
